/**
 * https://confluence.alo7.cn/pages/viewpage.action?pageId=63623576
 * 目录显示规则：
 两层目录结构：课程目录-一级目录副标题+二级目录主标题
 一层目录结构：一级目录主标题
 （需要配合acme的发版）
 * @param items
 */
const DEFAULT_NAME = '详情';
export const getCatalogName = items => {
  const { targetCatalogUuid } = nx.$root.params;
  const finder = (key, value) => value.uuid == targetCatalogUuid;
  if (!items.length) return DEFAULT_NAME;
  const tree = new nx.Tree(items);
  const target = tree.find(finder);
  if (!target) return DEFAULT_NAME;
  if (target.level === 1) return target.title;
  const parent = tree.parent(finder);
  return [parent.subtitle, target.title].filter(Boolean).join('-');
};
